define(["jquery", "underscore", "marionette"], function (
    $,
    _,
    Marionette,
  ) {
    let focusIndex = 0;

    return Marionette.View.extend({
      el: "#content_layout",
  
      ui: {
        searchInput: ".search-input",
        removeInputValueBtn: ".remove-value-button",
        resultContainer: ".result-container",
      },
  
      events: {
        "keydown @ui.searchInput": "onKeydown",
        "input @ui.searchInput": "onInputChange",
        "click @ui.removeInputValueBtn": "onClickRemoveInputValueBtn",
      },
  
      initialize: function () {
        this.bindUIElements();
        this.ui.searchInput.val("");
        this.ui.resultContainer.html("");
        this.debouncedFetchFAQs = _.debounce(this.fetchFAQs, 1000).bind(this);
        this.currentRequest = null; // 현재 진행중인 요청을 추적하기 위한 변수 추가
        this.lastSearchValue = "";
      },

      onKeydown: function (event) {
        const elements = $(this.ui.resultContainer).children('.result-list');

        // Handle enter
        if (event.keyCode === 13 && focusIndex > 0) {
          const href = elements.eq(focusIndex - 1).find('a').attr('href');

          window.location = href;

          return;
        }

        // Handle Arrow-Up or Arrow-Down
        elements.eq(focusIndex - 1).removeClass('focus');
        if (event.keyCode === 38) focusIndex = Math.max(1, focusIndex - 1);
        else if (event.keyCode === 40) focusIndex = Math.min(elements.length, focusIndex + 1);
        elements.eq(focusIndex - 1).addClass('focus');

        // Handle Scroll
        const element = elements.eq(Math.max(0, focusIndex - 1));

        if (element.length > 0) element[0].scrollIntoView({ block: "center", behavior: "smooth" });
      },

      onInputChange: function () {
        var newSearchValue = this.ui.searchInput.val().trim();

        if (newSearchValue === this.lastSearchValue) return;

        this.lastSearchValue = newSearchValue;
        focusIndex = 0;
        this.ui.resultContainer.html("");
  
        // 이전 요청이 있다면 취소
        if (this.currentRequest) this.currentRequest.abort();
  
        this.debouncedFetchFAQs(newSearchValue);
      },
  
      showLoading: function () {
        this.ui.resultContainer.append(
          `<div class="loading-text">Searching...</div>`
        );
      },
  
      removeLoading: function () {
        this.ui.resultContainer.find(".loading-text").remove();
      },
  
      fetchFAQs: function (searchValue) {
        /**
         * - 검색어가 세글자 미만인 경우 API 호출 방지
         * - Locale이 한국인 경우 예외적으로 두글자 미만인 경우 API 호출 방지
         */
        if (searchValue.length < (window.languageCode === 'ko_KR' ? 2: 3)) return;
  
        const params = {
          page: 1,
          limit: 100,
          type: "landprime",
          value: searchValue,
          isSearchingBody: 1,
          languageCode: window.languageCode
        };
  
        this.showLoading();
  
        // 현재 요청을 저장
        this.currentRequest = $.ajax("/rest_help_center/faqs_search", {
          method: "GET",
          data: params,
          dataType: "json",
          success: (response) => {
            this.removeLoading();
            this.currentRequest = null;
  
            if (response && response.data) {
              response.data.forEach((data) => {
                this.renderFAQs(data);
              });
            }
          },
          error: (error) => {
            this.currentRequest = null;
            if (error.status === 404) {
              return this.renderNoResults();
            } else
              this.renderNoResults(
                "There are something wrong with your request. Try again later."
              );
          },
        });
      },
  
      renderFAQs: function (data) {
        this.ui.resultContainer.find(".no-results").remove();
  
        let searchKeyword = this.ui.searchInput.val().trim();
        let path = data.metaTag.path;
        let title = data.title;
  
        const highlightedTitle = this.keywordHighlight(title, searchKeyword);
  
        const list = `<p class="result-list"><a href="/help_center/${path}">${highlightedTitle}</a></p>`;
        this.ui.resultContainer.append(list);
      },
  
      keywordHighlight: function (text, keyword) {
        if (!keyword || !text) return text;
  
        const regex = new RegExp(`(${keyword})`, "gi");
        return text.replace(regex, '<span style="color: #0049ff;">$1</span>');
      },
  
      renderNoResults: function (text) {
        const searchValue = this.ui.searchInput.val().trim();
        this.ui.resultContainer.html(
          `<p class="no-results" style="padding: 12px 16px;">${
            window.translation_no_result
          } <span style="color: #0049ff">${text || searchValue}</span></p>`
        );
      },
  
      onClickRemoveInputValueBtn: function (e) {
        e.preventDefault();
  
        if (this.currentRequest) {
          this.currentRequest.abort();
          this.currentRequest = null;
        }
        this.ui.searchInput.val("");
        this.ui.resultContainer.html("");
      },
    });
  });
  